export class AiSkillsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getAiSkills() {
    return this.#http.get('/ai-skills');
  }

  async getAiSkillTemplates() {
    return this.#http.get('/ai-skills/templates');
  }

  async createAiSkill(body) {
    return this.#http.post('/ai-skills', body);
  }

  async updateAiSkill({ id, ...body }) {
    return this.#http.put(`/ai-skills/${id}`, body);
  }

  async deleteAiSkill(id) {
    return this.#http.delete(`/ai-skills/${id}`);
  }

  async cloneAiSkill(id) {
    return this.#http.post(`/ai-skills/${id}/clone`);
  }

  async enableAiSkill(id) {
    return this.#http.get(`/ai-skills/${id}/enable`);
  }

  async disableAiSkill(id) {
    return this.#http.get(`/ai-skills/${id}/disable`);
  }

  // LEN-213 (designer D2): replaces the skill's check contributions (null clears them); 400 lists
  // every problem and saves nothing.
  async setAiSkillCheckContributions({ id, contributions }) {
    return this.#http.put(`/ai-skills/${id}/check-contributions`, contributions);
  }
}
